<template>
  <div class="modal-wrap">
    <el-dialog title="选择授权账户" @close="closeModal" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false">
      <div class="modal-content">
        <div class="modal-search">
          <el-input class="search-item" placeholder="请输入名称或ID" v-model="filterData.search" suffix-icon="el-icon-search" @input="searchData"></el-input>
          <el-select class="search-item" v-model="filterData.managerId" filterable placeholder="选择mcc" @change="searchData">
            <el-option label="全部mcc" :value="null"></el-option>
            <el-option v-for="item in mcclist" :key="item.managerId" :label="item.managerName" :value="item.managerId"></el-option>
          </el-select>
          <el-select v-model="filterData.accountStatus" filterable placeholder="账户状态" class="search-item" @change="searchData">
            <el-option label="全部账户状态" :value="null"></el-option>
            <el-option label="不可用" :value="0"></el-option>
            <el-option label="可用" :value="1"></el-option>
          </el-select>
          <el-select style="margin-right: 0px" v-model="filterData.authStatus" filterable placeholder="授权状态" class="search-item" @change="searchData">
            <el-option label="全部授权状态" :value="null"></el-option>
            <el-option label="未授权" :value="0"></el-option>
            <el-option label="已授权" :value="1"></el-option>
          </el-select>
        </div>
        <div class="modal-table">
          <el-table :data="tableData" @selection-change="handleSelectionChange" :row-key="getKey" ref="account" style="width: 100%">
            <el-table-column type="selection" width="55" reserve-selection> </el-table-column>
            <el-table-column prop="advertiserId" label="账户ID"> </el-table-column>
            <el-table-column prop="accountName" label="账户名称"> </el-table-column>
            <el-table-column prop="managerName" label="mcc"> </el-table-column>
            <el-table-column prop="accountStatus" label="状态">
              <template slot-scope="scope">
                {{ scope.row.accountStatus === 1 ? "可用" : "不可用" }}
              </template>
            </el-table-column>
            <el-table-column prop="authStatus" label="授权状态">
              <template slot-scope="scope">
                {{ scope.row.authStatus === 1 ? "已授权" : "未授权" }}
              </template>
            </el-table-column>
          </el-table>
          <self-pagination
            :total="pageData.total"
            :pageSize="pageData.size"
            :currentPage="pageData.page"
            @getCurrentPage="getCurrentPage"
            @handleSizeChange="changePageSize"
            :hideSiglePage="false"
            ref="tabelPagination"
          ></self-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeModal">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getGoogleAccountManagerList, getGoogleAccountList, bindGoogleAccount } from "@/api/promotion-google";
export default {
  data() {
    return {
      dialogVisible: false,
      filterData: {
        search: "",
        managerId: null,
        accountStatus: null,
        authStatus: null,
      },
      mcclist: [],
      tableData: [],
      multipleSelection: [],
      pageData: {
        size: 10,
        page: 1,
        total: 10,
      },
    };
  },

  computed: {},

  watch: {},

  mounted() {},

  methods: {
    showModal() {
      this.getList();
      getGoogleAccountManagerList({
        accountId: this.$route.query.accountId,
      }).then((res) => {
        this.mcclist = res.data;
      });
      this.dialogVisible = true;
    },
    getKey(row) {
      return row.id;
    },
    searchData() {
      this.pageData.page = 1;
      this.getList();
    },
    getList() {
      getGoogleAccountList({
        accountId: this.$route.query.accountId,
        pageNum: this.pageData.page,
        pageSize: this.pageData.size,
        ...this.filterData,
      }).then((res) => {
        this.tableData = res.data.list;
        this.pageData.total = res.data.total;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getCurrentPage(page) {
      this.pageData.page = page;
      this.getList();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getList();
    },
    closeModal() {
      this.dialogVisible = false;
      this.$router.replace({ query: {} });
    },
    handleConfirm() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请至少选择一个账户");
      } else {
        bindGoogleAccount(this.multipleSelection.map((item) => item.id)).then((res) => {
          if (res.code === "0000") {
            this.closeModal();
            this.$message({
              message: "绑定成功",
              type: "success",
            });
            this.$emit("successCallBack");
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.modal-wrap {
  .modal-content {
    .modal-search {
      display: flex;
      margin-bottom: 12px;
      .search-item {
        width: 25%;
        margin-right: 16px;
      }
    }
  }
}
</style>
